(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('CustomUpdatesDialogController', CustomUpdatesDialogController);

    CustomUpdatesDialogController.$inject = ['$timeout', 'TabObjects', 'TabActionsQueue', '$state', '$uibModalInstance', 'scripts'];

    function CustomUpdatesDialogController($timeout, TabObjects, TabActionsQueue, $state, $uibModalInstance, scripts) {
        var vm = this;

        vm.newCommand = $state.params.oldCommands;
        vm.tabobjects = TabObjects.query();
        vm.tabactionsqueues = TabActionsQueue.query();
        vm.scripts = scripts;

        vm.writeCommandInTextbox = function() {
            if (vm.script)
                vm.newCommand = writeScriptName(vm.script.scriptName);
            else
                vm.newCommand = null;
        };

        vm.resetScriptBox = function() {
            vm.script = null;
        };

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        vm.save = function () {
            vm.isSaving = true;
            $uibModalInstance.close(vm.newCommand);
            vm.isSaving = false;
        };

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function writeScriptName (scriptName) {
            return '#' + scriptName + '#';
        }
    }
})();
